import React, { useState, useEffect } from "react";
import axios from "axios";

const fetchCompanyData = async () => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({ useremail: "" });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      "https://casaahaanahotels.com/search_company_data",
      requestOptions
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching company data:", error);
    return [];
  }
};

const AssessmentTable = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [loadingnew, setLoading1] = useState(false);

  const [loadingnewuser, setLoading2] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://casaahaanahotels.com/list_assessments"
        );
        setAssessments(response.data.result);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching assessments:", error);
      }
    };

    fetchData();
  }, []);

  function sendButtonClickHandler(assessment) {
    setLoading2(true);
    const { score, timestamp, validity, driver_details, assessmentid } =
      assessment;

    const getCurrentDate = () => {
      const date = new Date();
      return `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
        .getDate()
        .toString()
        .padStart(2, "0")}/${date.getFullYear()}`;
    };
    const formattedDate = new Date(timestamp).toLocaleDateString("en-US");
    const validityDate = new Date(validity).toLocaleDateString("en-US");

    const payload = {
      sendto: driver_details.DriverEmail,
      replyTo: "assessment@starbehaviors.com",
      title: "Star Behaviors Assessment Results",
      drivername: `${driver_details.FirstName} ${driver_details.LastName}`,
      driveraddress:
        `${driver_details.Street || ""} ${driver_details.CurrentCity || ""} ${
          driver_details.CurrentState || ""
        }`.trim() || "Not Provided",
      driverphone: driver_details.PhoneNumber || "Not Provided",
      useremail: driver_details.DriverEmail,
      assessment_date: formattedDate,
      stars: score,
      getCurrentDate: getCurrentDate(),
      assessmentRecipient: selectedEmails,
    };

    const sendmail =
      payload.stars >= 3
        ? `<body style="font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0"><div class="container" style="width:96%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,.2);border-radius:8px"><div class="header" style="text-align:center"><img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" alt="Star Behaviors Logo" style="width:auto;max-width:auto;height:100px;display:block;margin:0 auto"></div><div class="content" style="margin-top:20px;line-height:1.6"><h2 style="text-align:center">Assessment Completed - Congratulations on Your Achievement!</h2><p style="font-size: 16px;">Dear ${payload.drivername},</p><p style="font-size: 16px;">We're thrilled to inform you that you've successfully completed [Part 1] of the Star Behaviors Assessment. Your journey towards a fulfilling career has taken a significant leap forward!</p><center><h3>Your Star Score:</h3><img src="https://starbehaviors.com/uploadimage/${payload.stars}.png"></center><p style="font-size: 16px;">Your <b>${payload.stars}-star rating</b> signifies your good alignment with the required behavioral traits for this position, indicating a high likelihood of long-term satisfaction and fulfillment in this career. Individuals receiving a ${payload.stars}-star rating are normally well-suited for both formal (e.g., post-secondary training) and informal (on-the-job) training programs.</p><p style="font-size: 16px;">Whether you're entering the job market for the first time, considering a career change, or already established in this field, you can confidently pursue this profession. Prospective employers are likely to be eager to explore training and employment opportunities with candidates of your caliber.</p><h3>What This Means for Your Career</h3><p style="font-size: 16px;">Receiving a ${payload.stars}-star rating places you in an enviable position. It signifies that you're exceptionally well-suited for a range of professional development opportunities, encompassing both formal education (such as post-secondary training programs) and practical, on-the-job experiences.</p><p style="font-size: 16px;">Whether you're stepping into the job market for the first time, contemplating a career shift, or furthering your journey in your current field, this score empowers you to confidently advance. Employers are always on the lookout for candidates of your caliber and potential, making you a desirable prospect for training and employment opportunities.</p><p style="font-size: 16px;">At Star Behaviors, LLC, we take pride in guiding individuals towards careers that not only match their skills and interests but also ignite their passion. Thank you for trusting us on this pivotal journey. Remember, your success isn't just written in the stars—it's also shaped by your dedication and our support.</p><p style="font-size: 16px;">Wishing you a stellar career ahead!</p><p>Warm regards,</p><p style="font-size: 16px;">TJ Graff<br>CEO<br>Star Behaviors, LLC</p></div><div class="footer" style="text-align:center;margin-top:20px;font-style:italic"><b>Powered by Star Behaviors.</b></div></div></body>`
        : `<body style="font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0"><div class="container" style="width:96%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,.2);border-radius:8px"><div class="header" style="text-align:center"><img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" alt="Star Behaviors Logo" style="width:auto;max-width:auto;height:100px;display:block;margin:0 auto"></div><div class="content" style="margin-top:20px;line-height:1.6"><h2 style="text-align:center">Assessment Completed</h2><p style="font-size: 16px;">Dear ${payload.drivername},</p><p style="font-size: 16px;">We're thrilled to inform you that you've successfully completed [Part 1] of the Star Behaviors Assessment. Your journey towards a fulfilling career has taken a significant leap forward!</p><center><h3>Your Star Score:</h3><img src="https://starbehaviors.com/uploadimage/${payload.stars}.png"></center><p style="font-size: 16px;">The Star Behaviors Behavioral Assessment you've just completed is built upon an extensive job analysis involving individuals who have achieved lasting success and contentment in this career. Our research has identified numerous behaviors critical for your sustained happiness in this field. Research findings indicate that individuals scoring ${payload.stars} stars or lower are unlikely to experience long-term fulfillment or happiness in this profession.</p><p style="font-size: 16px;">Our partners are primarily interested in exploring training and employment opportunities with candidates who score 3, 4, or 5 stars. To ensure your enduring job satisfaction, we encourage you to consider completing one of our various other compatibility self-assessments to find the career that is a perfect fit for you!</p><p>Warm regards,</p><p style="font-size: 16px;">TJ Graff<br>CEO<br>Star Behaviors, LLC</p></div><div class="footer" style="text-align:center;margin-top:20px;font-style:italic"><b>Powered by Star Behaviors.</b></div></div></body>`;

    const queryString = `replyTo=${payload.replyTo}&sendto=${
      payload.sendto
    }&title=${payload.title}&body=${encodeURIComponent(sendmail)}`;

    var xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      "https://starbehaviors.com/sbassesmentsendmails.php?" + queryString,
      true
    );
    xhr.send();

    alert("Successfully Send Email");

    setLoading2(false);
  }

  // function sendButtonClickHandleradmin(assessment) {
  //   if (selectedEmails == "") {
  //     alert("Select company");
  //     return false;
  //   }
  //   setLoading1(true);
  //   const { score, timestamp, validity, driver_details, assessmentid } =
  //     assessment;

  //   const getCurrentDate = () => {
  //     const date = new Date();
  //     return `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
  //       .getDate()
  //       .toString()
  //       .padStart(2, "0")}/${date.getFullYear()}`;
  //   };
  //   const formattedDate = new Date(timestamp).toLocaleDateString("en-US");
  //   const validityDate = new Date(validity).toLocaleDateString("en-US");

  //   const payload = {
  //     sendto: driver_details.DriverEmail,
  //     replyTo: "assessment@starbehaviors.com",
  //     title: "Star Behaviors Assessment Results",
  //     drivername: `${driver_details.FirstName} ${driver_details.LastName}`,
  //     driveraddress:
  //       `${driver_details.Street || ""} ${driver_details.CurrentCity || ""} ${
  //         driver_details.CurrentState || ""
  //       }`.trim() || "Not Provided",
  //     driverZip: `${driver_details.ZipCode}`,
  //     driverphone: driver_details.PhoneNumber || "Not Provided",
  //     useremail: driver_details.DriverEmail,
  //     assessment_date: formattedDate,
  //     stars: score,
  //     getCurrentDate: getCurrentDate(),
  //     assessmentRecipient: selectedEmails,
  //   };

  //   const body = `
  //   <body style="font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0">
  //     <div class="container" style="width:96%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,.2);border-radius:8px">
  //       <div class="header" style="text-align:center;margin-bottom:10px">
  //         <img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" alt="Star Behaviors Logo" style="width:auto;height:100px">
  //       </div>
  //       <h2 style="text-align:center;margin-top:0">Star Behaviors Assessment Results</h2>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Subject:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">Star Behaviors Assessment Results</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">From:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">admin@starbehaviors.com</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Date:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">${payload.getCurrentDate}</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">To:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">${payload.assessmentRecipient}</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Name:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">${payload.drivername}</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Address:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">${payload.driveraddress}</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px"><label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Zip Code:</label><span style="width:60%;text-align:left;font-size: 16px;">${payload.driverZip}</span></div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Phone Number:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">${payload.driverphone}</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Email:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">${payload.useremail}</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Assessment Completed:</label>
  //         <span style="width:60%;text-align:left;font-size: 16px;">${payload.assessment_date}</span>
  //       </div>
  //       <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
  //         <label style="font-weight:700;width:30%;margin-right:5px;font-size: 16px;">Score:</label>
  //         <span style="width:70%;text-align:left;font-size: 16px;">
  //           <img src="https://starbehaviors.com/uploadimage/${payload.stars}.png" />
  //         </span>
  //       </div>
  //       <div class="powered" style="text-align:center;margin-top:40px;font-style:italic">Powered by Star Behaviors.</div>
  //     </div>
  //   </body>
  // `;

  //   const queryString = `replyTo=${encodeURIComponent(
  //     payload.replyTo
  //   )}&sendto=${encodeURIComponent(
  //     payload.assessmentRecipient
  //   )}&title=${encodeURIComponent(payload.title)}&body=${encodeURIComponent(
  //     body
  //   )}`;

  //   const xhr = new XMLHttpRequest();
  //   xhr.open(
  //     "GET",
  //     "https://starbehaviors.com/sbassesmentsendmails.php?" + queryString,
  //     true
  //   );
  //   xhr.send();

  //   alert("Successfully Send Email");
  //   setLoading1(false);
  // }



  function sendButtonClickHandleradmin(assessment) {
  if (selectedEmails == "") {
    alert("Select company");
    return false;
  }
  setLoading1(true);

  const { score, timestamp, validity, driver_details, assessmentid } = assessment;

  const getCurrentDate = () => {
    const date = new Date();
    return `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
      .getDate()
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  const formattedDate = new Date(timestamp).toLocaleDateString("en-US");
  const validityDate = new Date(validity).toLocaleDateString("en-US");

  const payloadBase = {
    replyTo: "assessment@starbehaviors.com",
    title: "Star Behaviors Assessment Results",
    drivername: `${driver_details.FirstName} ${driver_details.LastName}`,
    driveraddress: `${driver_details.Street || ""} ${driver_details.CurrentCity || ""} ${driver_details.CurrentState || ""}`.trim() || "Not Provided",
    driverZip: `${driver_details.ZipCode}`,
    driverphone: driver_details.PhoneNumber || "Not Provided",
    useremail: driver_details.DriverEmail,
    assessment_date: formattedDate,
    stars: score,
    getCurrentDate: getCurrentDate(),
  };

  // Split selectedEmails into array, trim spaces, filter empty strings
  const recipients = selectedEmails
    .split(',')
    .map(email => email.trim())
    .filter(email => email.length > 0);

  console.log("Recipients to send to:", recipients);

  recipients.forEach((recipient) => {
    const body = `
      <body style="font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0">
        <div class="container" style="width:96%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,.2);border-radius:8px">
          <div class="header" style="text-align:center;margin-bottom:10px">
            <img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" alt="Star Behaviors Logo" style="width:auto;height:100px">
          </div>
          <h2 style="text-align:center;margin-top:0">Star Behaviors Assessment Results</h2>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Subject:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">Star Behaviors Assessment Results</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">From:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">admin@starbehaviors.com</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Date:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">${payloadBase.getCurrentDate}</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">To:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">${recipient}</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Name:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">${payloadBase.drivername}</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Address:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">${payloadBase.driveraddress}</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Zip Code:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">${payloadBase.driverZip}</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Phone Number:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">${payloadBase.driverphone}</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Email:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">${payloadBase.useremail}</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:40%;margin-right:5px;font-size: 16px;">Assessment Completed:</label>
            <span style="width:60%;text-align:left;font-size: 16px;">${payloadBase.assessment_date}</span>
          </div>
          <div class="form-field" style="background-color:#f9f9f9;padding:8px;margin-bottom:10px;display:flex;border:1px solid #ddd;border-radius:4px">
            <label style="font-weight:700;width:30%;margin-right:5px;font-size: 16px;">Score:</label>
            <span style="width:70%;text-align:left;font-size: 16px;">
              <img src="https://starbehaviors.com/uploadimage/${payloadBase.stars}.png" />
            </span>
          </div>
          <div class="powered" style="text-align:center;margin-top:40px;font-style:italic">Powered by Star Behaviors.</div>
        </div>
      </body>
    `;

    const queryString = `replyTo=${encodeURIComponent(payloadBase.replyTo)}&sendto=${encodeURIComponent(recipient)}&title=${encodeURIComponent(payloadBase.title)}&body=${encodeURIComponent(body)}`;

    const xhr = new XMLHttpRequest();
    xhr.open("GET", "https://starbehaviors.com/sbassesmentsendmails.php?" + queryString, true);
    xhr.send();
  });

  alert("Successfully Sent Emails");
  setLoading1(false);
}


  useEffect(() => {
    const loadCompanies = async () => {
      const data = await fetchCompanyData();
      setCompanies(data);
    };

    loadCompanies();
  }, []);

  const handleChange = (event) => {
    // Get the comma-separated email string from the option value
    const emailString = event.target.value;

    // Split the string by commas and trim spaces to form the array of emails
    // const emails = emailString.split(',').map(email => email.trim().replace(/"/g, ''));

    // Set the selected emails in state or use it as needed
    setSelectedEmails(emailString);
  };

  return (
    <div>
      <h2 style={{ textAlign: "center" }}>Assessment List</h2>
      <div>
        <select onChange={handleChange}>
          <option value="0">Select a company</option>
          {companies.map((company) => (
            <option
              key={company.id}
              value={company.assessmentRecipient.join(",")} // Join emails with comma
            >
              {company.companyname}
            </option>
          ))}
        </select>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Full Name</th>
              <th>Email</th>
              <th>Star Score</th>
              <th>Assessment Completed</th>
              <th>Validity</th>
              <th>Send Driver Mail</th>
              <th>Send Admin Mail</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {assessments.map((assessment, index) => {
              if (assessment.driverid && assessment.score) {
                const formattedDate = new Date(
                  assessment.timestamp
                ).toLocaleDateString("en-US");
                const validityDate = new Date(
                  assessment.validity
                ).toLocaleDateString("en-US");

                return (
                  <tr key={`${assessment.assessementid}-${index}`}>
                    <td>{`${assessment.driver_details.FirstName} ${assessment.driver_details.LastName}`}</td>
                    <td>{assessment.driver_details.DriverEmail}</td>
                    <td>
                      <img
                        src={`https://starbehaviors.com/uploadimage/${assessment.score}.png`}
                      />
                    </td>
                    <td>{formattedDate}</td>
                    <td>{validityDate}</td>
                    <td>
                      <button
                        onClick={() => sendButtonClickHandler(assessment)}
                      >
                        {loadingnewuser ? "Sending..." : "Send User Mail"}
                      </button>
                    </td>
                    <td>
                      <button
                        onClick={() => sendButtonClickHandleradmin(assessment)}
                      >
                        {loadingnew ? "Sending..." : "Send Admin Mail"}
                      </button>
                    </td>
                    <td>
                      <a
                        href={`https://sbnew.starbehaviors.com/user-landingpage/showassessment/${assessment.assessementid}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                    </td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AssessmentTable;
